const MAX_CHANNEL = 255;

/**
 * CSS colour of an RGBA quadruple in 0..1, as WebGL gets it (theme.js).
 *
 * @param {ArrayLike<number>} values
 * @param {number} [offset] - index of the red channel
 * @returns {string}
 */
export const colorCss = (values, offset = 0) => {
  const red = Math.round(values[offset] * MAX_CHANNEL);
  const green = Math.round(values[offset + 1] * MAX_CHANNEL);
  const blue = Math.round(values[offset + 2] * MAX_CHANNEL);

  return `rgba(${red}, ${green}, ${blue}, ${values[offset + 3]})`;
};
